import { getContractBasedDataSelector, getSimpleDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from 'store/rootReducer';

export const PostboxDataSelector = getSimpleDataSelector((state: RootState) => state.postbox);

export const PostboxContractDataSelector = getContractBasedDataSelector((state: RootState) => state.contractPostbox);
